export const ScalarMode = {
  NONE: 0,
  COLORS: 1,
  LABELS: 2,
};

export default { ScalarMode };
